
import { Options, Vue } from "vue-class-component";
import CrudTabelaPreco from "../../components/orcamento/CrudTabelaPreco.vue";

@Options({
  props: {
    isNew: Boolean,
    idTabelaPreco: Number
  },
  components: {
    CrudTabelaPreco
  }
})
export default class TabelaPreco extends Vue {
  isNew?: boolean;
  idTabelaPreco?: number;
}
